import { Value, Option, Constraint, FormFieldsConfig } from "./FormEntities";

function getInitValues(formConfig: FormFieldsConfig) {
  const configValues: Record<string, Value> = {};

  for (let fieldName in formConfig) {
    if ("default" in formConfig[fieldName]) {
      configValues[fieldName] = formConfig[fieldName]["default"] ?? "";
    } else {
      configValues[fieldName] = "";
    }
  }

  return configValues;
}

function getConstraints(formConfig: FormFieldsConfig) {
  const configValues: Record<string, Array<Constraint>> = {};
  for (let fieldName in formConfig) {
    if (formConfig[fieldName]["constraints"] !== undefined) {
      configValues[fieldName] = formConfig[fieldName]["constraints"]!;
    }
  }
  return configValues;
}

function getOptions(formConfig: FormFieldsConfig) {
  const configValues: Record<string, Array<Option> | Function> = {};

  for (let fieldName in formConfig) {
    if (formConfig[fieldName]["options"] !== undefined) {
      configValues[fieldName] = formConfig[fieldName]["options"]!;
    }
  }
  return configValues;
}

export default {
  getInitValues,
  getConstraints,
  getOptions,
} as const;
